import React, { useState } from 'react';
import { Sparkles, Loader } from 'lucide-react';

const AIAssistant = ({ onSuggest }) => {
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const [suggestion, setSuggestion] = useState(null);

    const handleAskAI = () => {
        if (!prompt.trim()) return;

        setLoading(true);
        // Mock AI response
        setTimeout(() => {
            const mockSuggestion = {
                date: new Date().toISOString().split('T')[0],
                time: '14:00',
                reason: "Based on your preference for afternoon meetings and low conflict probability."
            };
            setSuggestion(mockSuggestion);
            setLoading(false);
        }, 1500);
    };

    return (
        <div className="glass-card p-4 mb-6">
            <div className="flex items-center gap-2 mb-3 text-accent">
                <Sparkles size={20} />
                <h3 className="font-semibold">AI Scheduling Assistant</h3>
            </div>

            <div className="flex gap-2 mb-4">
                <input
                    type="text"
                    value={prompt}
                    onChange={e => setPrompt(e.target.value)}
                    placeholder="e.g., Find me a slot next Tuesday afternoon..."
                    className="flex-1 bg-white/5 border border-white/10 rounded-lg px-4 py-2 text-white focus:border-accent outline-none text-sm"
                />
                <button
                    onClick={handleAskAI}
                    disabled={loading}
                    className="btn-primary px-4 py-2 flex items-center gap-2"
                >
                    {loading ? <Loader className="animate-spin" size={16} /> : 'Ask AI'}
                </button>
            </div>

            {suggestion && (
                <div className="bg-white/5 border border-accent/30 rounded-lg p-3 animate-fade-in">
                    <p className="text-sm text-white/80 mb-2">{suggestion.reason}</p>
                    <div className="flex justify-between items-center">
                        <span className="text-accent font-medium">
                            Suggested: {suggestion.time} on {suggestion.date}
                        </span>
                        <button
                            onClick={() => onSuggest(suggestion)}
                            className="text-xs bg-accent/20 text-accent px-3 py-1 rounded hover:bg-accent/30 transition-colors"
                        >
                            Use Slot
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AIAssistant;
